import React from 'react'
import PropTypes from 'prop-types'

import { withNamespaces } from '@edulastic/localization'
import { FlexContainer } from '@edulastic/common'

import {
  Container,
  ZoneTitle,
  Loading,
  IconUpload,
  WarningText,
  WarningIcon,
} from './styled'

const getMaxFileSizeText = (maxSizeInKB) => {
  if (!maxSizeInKB) return ''
  if (maxSizeInKB >= 1024) {
    const sizeInMB = maxSizeInKB / 1024
    const displaySize =
      sizeInMB % 1 === 0 ? sizeInMB.toFixed(0) : sizeInMB.toFixed(2)
    return `${displaySize} MB`
  }
  return `${maxSizeInKB} KB`
}

const StyledDropZone = ({
  loading,
  isDragActive,
  t,
  dropzoneSettings: { name, allowedFiles, maxSize },
  children,
  containerHeight,
  containerMargin,
}) => {
  const isVideo = name === 'Video'
  const uploadType = (name || 'File').toLowerCase()

  return (
    <Container
      alignItems="center"
      justifyContent="center"
      isDragActive={isDragActive}
      flexDirection="column"
      height={containerHeight}
      margin={containerMargin}
    >
      {loading ? (
        <FlexContainer
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Loading type="loading" />
        </FlexContainer>
      ) : (
        <>
          <FlexContainer
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            style={{
              width: '100%',
              flex: 1,
              marginTop: '20px',
              marginBottom: '20px',
              padding: '16px',
              boxSizing: 'border-box',
            }}
          >
            <IconUpload isDragActive={isDragActive} />
            <ZoneTitle textRole="title">
              {t('component.dropZone.mediaDragDrop', { mediaType: uploadType })}
            </ZoneTitle>
            <ZoneTitle textRole="or">
              {t('component.dropZone.mediaOr')}
            </ZoneTitle>
            <ZoneTitle textRole="upload">
              {t('component.dropZone.mediaUpload')}
            </ZoneTitle>
            <ZoneTitle textRole="formats">
              {t(
                maxSize
                  ? 'component.dropZone.mediaFilesWithMaxSize'
                  : 'component.dropZone.mediaFiles',
                {
                  allowedFiles,
                  maxSize: getMaxFileSizeText(maxSize),
                }
              )}
            </ZoneTitle>
            {isVideo && (
              <WarningText>
                <WarningIcon type="warning" />
                {t('component.dropZone.webmKioskModeHelpText')}
              </WarningText>
            )}
          </FlexContainer>
          {children}
        </>
      )}
    </Container>
  )
}

StyledDropZone.propTypes = {
  loading: PropTypes.bool.isRequired,
  isDragActive: PropTypes.any,
  t: PropTypes.func.isRequired,
  dropzoneSettings: PropTypes.object,
}

StyledDropZone.defaultProps = {
  isDragActive: false,
  dropzoneSettings: {
    name: 'Image',
    allowedFiles: 'PNG, JPG, GIF',
    maxSize: 1024,
  },
}

export default withNamespaces('assessment')(StyledDropZone)
